export default __webpack_public_path__ + "static/media/tech2.0ee700f6.jpg";